import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TwoSampleTComponent from './Component';

import { getOptionListForDropDown } from 'calculators/inferentialStatistics/oneSampleT';
import { round6AndFormatValue } from 'utilities/math';

import {
  getNumericalSummary,
  getVisibleNumericalSelectedParametersNames
} from 'store/dataset';
import {
  setSampleMeanFirst,
  setStandardDeviationFirst,
  setSampleSizeFirst,
  setSampleMeanSecond,
  setStandardDeviationSecond,
  setSampleSizeSecond,
  setNumericalRowDataSetFirst,
  setNumericalRowDataSetSecond,
  getNumericalRowDataSetFirst,
  getNumericalRowDataSetSecond
} from 'store/form/inferentialStatistics/twoSampleT';


class TwoSampleTContainer extends React.PureComponent {

  getNumericalOptionsDataSet = variableInAnotherDropDown => {
    const { numericalSelectedParametersNames, isFrequencyTable } = this.props;

    return getOptionListForDropDown({
      selectedParametersNames: numericalSelectedParametersNames,
      variableInAnotherDropDown,
      isFrequencyTable
    });
  };

  handleNumericalDropDownDataSetFirst = (_, newValue) => {
    this.props.handleNumericalDropDownDataSetFirst(newValue);
  };

  handleNumericalDropDownDataSetSecond = (_, newValue) => {
    this.props.handleNumericalDropDownDataSetSecond(newValue);
  };

  render () {
    return (
      <TwoSampleTComponent
        {...this.props}
        getNumericalOptionsDataSet={this.getNumericalOptionsDataSet}
        onGenerateMeanDataSetFirst={this.handleNumericalDropDownDataSetFirst}
        onGenerateMeanDataSetSecond={this.handleNumericalDropDownDataSetSecond}
      />
    );
  }
}

TwoSampleTContainer.propTypes = {
  numericalSelectedParametersNames: PropTypes.arrayOf(PropTypes.string),
  handleNumericalDropDownDataSetFirst: PropTypes.func.isRequired,
  handleNumericalDropDownDataSetSecond: PropTypes.func.isRequired,
  isFrequencyTable: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  numericalSelectedParametersNames: getVisibleNumericalSelectedParametersNames(
    state
  ),
  firstVariable: getNumericalRowDataSetFirst(state),
  secondVariable: getNumericalRowDataSetSecond(state)
});

const mapDispatchToProps = {
  handleNumericalDropDownDataSetFirst: value => (dispatch, getState) => {
    const state = getState();
    if (!value) {
      dispatch([
        setSampleMeanFirst('0'),
        setSampleSizeFirst('10'),
        setStandardDeviationFirst('1')
      ]);
      return;
    }

    const numericalSummary = getNumericalSummary(state);
    const valueDataSet = numericalSummary[value];

    dispatch([
      setSampleSizeFirst(valueDataSet.count),
      setSampleMeanFirst(round6AndFormatValue(valueDataSet.mean)),
      setStandardDeviationFirst(
        round6AndFormatValue(valueDataSet.sampleStandardDeviation)
      )
    ]);
  },
  handleNumericalDropDownDataSetSecond: value => (dispatch, getState) => {
    const state = getState();
    if (!value) {
      dispatch([
        setSampleMeanSecond('0'),
        setSampleSizeSecond('10'),
        setStandardDeviationSecond('1')
      ]);
      return;
    }

    const numericalSummary = getNumericalSummary(state);
    const valueDataSet = numericalSummary[value];

    dispatch([
      setSampleSizeSecond(valueDataSet.count),
      setSampleMeanSecond(round6AndFormatValue(valueDataSet.mean)),
      setStandardDeviationSecond(
        round6AndFormatValue(valueDataSet.sampleStandardDeviation)
      )
    ]);
  },
  handleFirstGroupInputs: () => dispatch => dispatch(setNumericalRowDataSetFirst('')),
  handleSecondGroupInputs: () => dispatch => dispatch(setNumericalRowDataSetSecond(''))
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TwoSampleTContainer);
